import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import {VENDOR_TAG_TYPE, TAGS_LIST_MAX_HEIGHT, QUOTE_TAG_TYPE_DISPLAY} from '../../constants/constants';
import {toggleIsSaved} from '../../actions/taggingDataActions';
import DeleteQuoteButton from "./DeleteQuoteButton";

export default function QuoteTags(props) {
    const dispatch = useDispatch();
    const [newTagLabel, setNewTagLabel] = useState("");
    const taggingData = useSelector(state => state.taggingData);
    const { quotesAndTags, isSaved } = taggingData;

    useEffect(() => {

    });

    const onTagSelect = (e, tag, tagType) => {
        props.onTagSelect(tag, tagType);
    }

    const onSaveClick = (e) => {
        props.onTagsSave();
    }

    const onNewTagChange = (e) => {
        const val = e.target.value;
        setNewTagLabel(val);
    }

    const onAddNewTag = (e) => {
        document.getElementById('input').value = '';
        props.onAddNewTag(newTagLabel);
    }

    // Render tags container
    const renderTagsContainer = (tags, tagsType) => {
        return (
            tags.map((tag, tagIndex) => {
                return (
                    renderTag(tag, tagIndex, tagsType)
                )
            })
        )
    }

    const renderQuotesLink = () => {
        if(props.renderQuotesLink) {
            return (
                <a href={props.quotesLink} target="_blank">
                    <Button type="button" variant="light" size="sm">
                        View all tagged quotes
                    </Button>
                </a>
            )
        }
    }

    // Render all tags
    const renderTags = () => {
        if (props.tags) {
            return (
                <>
                    {Object.keys(props.tags).map((tagsType, tagsTypeIndex) => {
                        if(props.tags[tagsType].length || tagsType == 'vendor_custom_tags') {
                            return (
                                <div key={tagsTypeIndex}>
                                    <h5 className="mt-3">{QUOTE_TAG_TYPE_DISPLAY[tagsType]}</h5>
                                    <div className={'overflow-auto custom-scroller custom-scroller-show-track'} style={{maxHeight: TAGS_LIST_MAX_HEIGHT}}>
                                        {tagsType == 'vendor_custom_tags' ? renderTagsContainer(props.newTags, VENDOR_TAG_TYPE) : ''}
                                        {renderTagsContainer(props.tags[tagsType], tagsType)}
                                    </div>
                                </div>
                            )
                        }
                    })}
                </>
            )
        }
    }

    // Render single tag
    const renderTag = (tag, index, tagType) => {
        let isChecked = false;
        if (props.selectedTags[tagType] && props.selectedTags[tagType].includes(tag)) {
            isChecked = true;
        }
        return (
            <div key={index} className={'d-flex'}>
                <Form.Check type='checkbox' className={'form-check-primary'}>
                    <Form.Check.Input type='checkbox' disabled={!props.isSelectingText} checked={isChecked} onChange={(e) => onTagSelect(e, tag, tagType)} />
                    <Form.Check.Label className={'content-styling text-dark fw-normal text-start'}>{tag}</Form.Check.Label>
                </Form.Check>
            </div>
        )
    }

    // Check is a tag is selected
    const checkTagsSelected = () => {
        let selected = false;
        Object.keys(props.selectedTags).map((key) => {
            if (props.selectedTags[key].length) {
                selected = true;
            }
        })
        return selected;
    }

    // Render delete passed from parent
    const deleteHandler = () => {
        if (!props.isNewQuote && props.selectedText) {
            if (Object.keys(quotesAndTags).length && quotesAndTags.vendor_quotes.find((vq) => vq.body == props.selectedText)) {
                const quoteID = quotesAndTags.vendor_quotes.find((vq) => vq.body == props.selectedText).id;
                return <DeleteQuoteButton quoteId={quoteID} btnText={'Delete this saved quote'} onDeleteHandler={props.onDeleteHandler} />
            }
        }
    }

    const renderNewTagForm = () => {
        return (
            <InputGroup className="pt-2 pb-3">
                <FormControl
                    placeholder="Create custom tag"
                    aria-label="Create custom tag"
                    aria-describedby="basic-addon2"
                    id={"input"}
                    onChange={(e) => onNewTagChange(e)}
                />
                <Button variant="success" className={''} onClick={(e) => onAddNewTag(e)} id="button-addon2" style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}>Add</Button>
            </InputGroup>
        )
    }

    const [saveButtonText, setSavedButtonText] = useState("Save quote and tags");

    useEffect(() => {
        if (isSaved) {
            dispatch(toggleIsSaved());
            setSavedButtonText("Saved");
        }   

        const intervalID = setTimeout(() =>  {
            setSavedButtonText("Save quote and tags");
        }, 2500);

        return () => clearInterval(intervalID);
    }, [isSaved]);

    const renderSaveButton = () => {
        if (saveButtonText == "Saved") {
            return (
                <>
                    {saveButtonText}<i className={"fas fa-check ps-2"}></i>
                </>
            )
        } else {
            return saveButtonText
        }
    }

    // Main component renderer
    return (
        <div className={'col-xl-4 p-0 bg-light overflow-visible h-100'}>
            <div style={{overflow: props.isSelectingText ? 'visible' : 'auto', width: props.isSelectingText ? '100%' : '0%',  height: props.isSelectingText ? '100%' : '0%',transition: 'all 0.3s'}}>
                <div className='border-bottom px-3 pt-3 mb-3'>
                    <Button variant="secondary" disabled={!checkTagsSelected()} className={'btn-block mb-2'} onClick={(e) => onSaveClick(e)}>
                        {renderSaveButton()}
                    </Button>

                    <div className={'d-flex justify-content-center mb-2'}>
                        {deleteHandler()} {renderQuotesLink()}
                    </div>
                </div>
                <div className='px-3 overflow-auto custom-scroller custom-scroller-transparent'>
                    <div style={{overflow: props.isSelectingText ? 'visible' : 'auto', height: '65vh'}}>
                        <h4 className={'page-title mt-1 mb-3'}>Tag this quote</h4>

                        {renderTags()}
                        {renderNewTagForm()}
                    </div>
                </div>
            </div>
        </div>
    )
}

